import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import RegisterPage from "./pages/RegisterPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import MaintenancePage from "./pages/MaintenancePage";
import GalleryPage from "./pages/GalleryPage";
import PrizesGalleryPage from "./pages/PrizesGalleryPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CookiePage from "./pages/CookiePage";
import CookieBanner from "./components/CookieBanner";
import IntroVideoOverlay from "./components/IntroVideoOverlay";
import { api } from "./lib/config";

function AppRoutes() {
  const location = useLocation();
  const [settings, setSettings] = useState(null);

  // Lightweight, first-party pageview tracker (essential, no PII, no cookies)
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return; // never track admin
    let sid = "";
    try {
      sid = sessionStorage.getItem("fp_sid") || "";
      if (!sid) {
        sid = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2)) + Date.now().toString(36);
        sessionStorage.setItem("fp_sid", sid);
      }
    } catch { /* sessionStorage blocked, just skip session id */ }
    api.post("/track/pageview", {
      path: location.pathname + (location.hash || ""),
      referrer: document.referrer || "",
      session_id: sid,
      screen: `${window.innerWidth}x${window.innerHeight}`,
    }).catch(() => { /* fail silently */ });
  }, [location.pathname, location.hash]);

  useEffect(() => {
    let mounted = true;
    const load = () => {
      api.get("/settings/public")
        .then((r) => mounted && setSettings(r.data))
        .catch(() => mounted && setSettings({}));
    };
    load();
    const int = setInterval(load, 30000);
    return () => { mounted = false; clearInterval(int); };
  }, []);

  // Admin routes always accessible (so admin can disable maintenance)
  const isAdminRoute = location.pathname.startsWith("/admin");

  if (settings?.maintenance_mode && !isAdminRoute) {
    return <MaintenancePage message={settings.maintenance_message} />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/premi/gallery" element={<PrizesGalleryPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/payment-success" element={<PaymentSuccessPage />} />
      <Route path="/payment-cancel" element={<PaymentCancelPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/termini" element={<TermsPage />} />
      <Route path="/cookie" element={<CookiePage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-fp-bg text-white font-body antialiased">
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <AppRoutes />
        <IntroVideoOverlay />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}
